module.exports = __webpack_public_path__ + "static/media/check.711361ae.svg";